<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ 'stores.forms.titles.UpdateDeliveryConfiguration' | translate }}</span>
    <button type="button" mat-icon-button class="treeslo-modal-header__close" mat-dialog-close
        [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <form [formGroup]="deliveryForm" class="treeslo-modal-form store-delivery-dialog__form">
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ 'stores.forms.fields.deliveryCity.label' | translate }}</mat-label>
            <input matInput formControlName="city" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ 'stores.forms.fields.deliveryState.label' | translate }}</mat-label>
            <input matInput formControlName="state" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ 'stores.forms.fields.deliveryPostalCode.label' | translate }}</mat-label>
            <input matInput formControlName="postalCode" />
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-stroked-button mat-dialog-close>{{ 'stores.forms.actions.Cancel' | translate }}</button>
        <button mat-flat-button color="primary" type="button" (click)="submitDelivery()"
            [disabled]="deliveryForm.invalid">
            {{ 'stores.forms.actions.Update' | translate }}
        </button>
    </div>
</mat-dialog-actions>
